import { useEffect } from "react";

export const useOnTabVisible = (onVisible) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        onVisible();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [onVisible]);
};
